import { get } from "lodash";
import moment from "moment";
import { ACORIS_MIN_AGE } from "utils/helpers/date";
import infoGradientIcon from "../Assets/icons/info_gradient.svg";
import Layout from "../Components/Layout";

function View({ onBack, project, translate }) {
  const age = moment().diff(
    moment(get(project, "contact.user.birthDate")),
    "years",
  );
  return (
    <Layout centered>
      <div className="acoris-not-eligible">
        <div className="acoris-not-eligible__content">
          <div className="acoris-not-eligible__header">
            <img
              src={infoGradientIcon}
              alt=""
              className="acoris-not-eligible__icon"
            />
            <h1 className="acoris-not-eligible__title">
              {translate?.TITLE || "Merci pour votre demande"}
            </h1>
            <p
              className="acoris-not-eligible__text"
              dangerouslySetInnerHTML={{
                __html:
                  translate?.TEXT || age < ACORIS_MIN_AGE || age > 120
                    ? translate?.TEXT_AGE
                    : translate?.TEXT_DEPARTMENT,
              }}
            />
          </div>

          <button
            className="acoris-not-eligible__button"
            onClick={onBack}
            // onClick={() => {
            //   window.location.href = "https://www.acoris-mutuelles.fr/";
            // }}
          >
            <span>
              {translate?.BUTTON?.BACK_TO_HOME || "Revenir à la page d’accueil"}
            </span>
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default View;
